import {
    createBrowserHistory,
    createHashHistory
} from "history";

export const history = createBrowserHistory();

// export const history = createHashHistory({
//     basename: '/',
//     hashType: 'slash'
// });



// export const link = 'http://dev.discoverself.pacewisdom.com'
// export const link = 'http://api-uat.opptimise.in'
// export const link = 'https://opptimise-api-uat.pacewisdom.in'
// export const link = 'https://opptimise-api-uat.pacewisdom.in'

export const link = "https://api.opptimise.in";



// WEBPACK FOOTER //
// ./src/_helpers/history.js